/** Fusos IANA usados no Brasil e Américas — evita digitação livre inválida. */
const BRAZIL_TIMEZONES = [
  "America/Sao_Paulo",
  "America/Manaus",
  "America/Cuiaba",
  "America/Campo_Grande",
  "America/Porto_Velho",
  "America/Rio_Branco",
  "America/Noronha",
  "America/Belem",
  "America/Fortaleza",
  "America/Recife",
  "America/Bahia",
  "America/Maceio",
  "America/Araguaina",
  "America/Boa_Vista",
];

const EXTRA_TIMEZONES = [
  "America/Buenos_Aires",
  "America/Santiago",
  "America/Lima",
  "America/Bogota",
  "America/Caracas",
  "America/Mexico_City",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "UTC",
];

const formatOffset = (timeZone) => {
  try {
    const parts = new Intl.DateTimeFormat("pt-BR", {
      timeZone,
      timeZoneName: "shortOffset",
    }).formatToParts(new Date());
    return parts.find((part) => part.type === "timeZoneName")?.value || "";
  } catch {
    return "";
  }
};

const cityLabel = (timeZone) => {
  const city = timeZone.split("/").pop()?.replace(/_/g, " ") || timeZone;
  return city;
};

const buildOption = (value) => {
  const offset = formatOffset(value);
  const suffix = offset ? ` (${offset})` : "";
  return {
    value,
    label: `${cityLabel(value)} — ${value}${suffix}`,
  };
};

const isValidTimeZone = (timeZone) => {
  const tz = String(timeZone || "").trim();
  if (!tz) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: tz }).format(new Date());
    return true;
  } catch {
    return false;
  }
};

const ALL_TIMEZONE_VALUES = [...new Set([...BRAZIL_TIMEZONES, ...EXTRA_TIMEZONES])];

export const TIMEZONE_OPTIONS = ALL_TIMEZONE_VALUES.map(buildOption);

export const DEFAULT_TIMEZONE = "America/Sao_Paulo";

/** Garante opção no select quando o valor salvo não está na lista curada. */
export const resolveTimezoneOptions = (currentValue) => {
  const current = String(currentValue || "").trim();
  if (!current || ALL_TIMEZONE_VALUES.includes(current)) {
    return TIMEZONE_OPTIONS;
  }
  if (isValidTimeZone(current)) {
    return [buildOption(current), ...TIMEZONE_OPTIONS];
  }
  return [
    { value: current, label: `${current} (inválido — escolha um fuso abaixo)` },
    ...TIMEZONE_OPTIONS,
  ];
};
